import React from "react";
import { Link } from "react-router-dom";
import "../styles/NotFound.css";

// آیکون خانه
const HomeIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 10.5L12 3L21 10.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1V10.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

// آیکون فروشگاه
const ShopIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 9.5V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.5M3 9.5l1.6-5A1 1 0 0 1 5.55 4h12.9a1 1 0 0 1 .95.68l1.6 5.02M3 9.5h18M9 20v-5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// آیکون ذره‌بین (گم‌شده)
const SearchOffIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" strokeWidth="1.6" />
    <path d="M20 20L15.2 15.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M8 8L13 13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M13 8L8 13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

function NotFound({
  storeSlug,
  title = "",
  subtitle = " ",
}) {
  const homeHref = "/";

  return (
    <section className="dokana notfound dokana-404">
      {/* بلاب‌های تزئینی پس‌زمینه */}
      <div className="notfound-blob notfound-blob-1" />
      <div className="notfound-blob notfound-blob-2" />
      <div className="notfound-blob notfound-blob-3" />

      <div className="container notfound-inner">
        <div className="notfound-badge">
          <span className="dot" />
          صفحه‌ی مورد نظر پیدا نشد
        </div>

        <h1 className="notfound-number">
          ۴<span className="accent">۰</span>۴
        </h1>

        <h2 className="notfound-title">{title}</h2>

        <p className="notfound-sub">{subtitle}</p>

        <div className="notfound-actions">
          <Link to={homeHref} className="btn btn-primary">
            <HomeIcon />
            بازگشت به صفحه اصلی
          </Link>
          {/* <Link to={homeHref + "#products"} className="btn btn-ghost">
            <ShopIcon />
            مشاهده محصولات
          </Link> */}
        </div>

        {/* کارت شناور تزئینی */}
        <div className="notfound-float-card">
          <div className="notfound-float-icon">
            <SearchOffIcon />
          </div>
          <div className="notfound-float-text">
            <b>۰</b> نتیجه برای این آدرس
          </div>
        </div>

        <div className="float-chip notfound-chip-1">
          <span className="badge-dot" />
          کد خطا: ۴۰۴
        </div>
        <div className="float-chip notfound-chip-2">مسیر یافت نشد</div>
      </div>
    </section>
  );
}

export default NotFound;
